import * as React from 'react';
import { useTheme } from 'styled-components';

const NavCommunityIcon = ({ isSelected }: { isSelected: boolean }) => {
	const theme = useTheme();
	const fillColor = isSelected ? theme.primaryBackground : 'white';

	return (
		<svg height="22" viewBox="0 0 21 24" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path
				d="M19.9202 9.55817C19.7522 9.21617 19.4042 9.00017 19.0232 9.00017H11.1402L12.0162 1.11017C12.0662 0.664173 11.8122 0.240173 11.3962 0.0721732C10.9792 -0.0978268 10.5022 0.0341732 10.2292 0.389173L0.229249 13.3892C-0.00275078 13.6912 -0.0437509 14.0992 0.125249 14.4412C0.294249 14.7842 0.642249 15.0002 1.02325 15.0002H8.90625L8.03025 22.8902C7.98025 23.3362 8.23425 23.7602 8.65025 23.9282C8.77125 23.9772 8.89825 24.0002 9.02325 24.0002C9.32725 24.0002 9.62325 23.8612 9.81625 23.6102L19.8162 10.6102C20.0482 10.3082 20.0882 9.90017 19.9202 9.55817Z"
				fill={fillColor}
			/>
		</svg>
	);
};

export default NavCommunityIcon;
